import React, { useState, useEffect, useContext } from "react";
import { withRouter, Link } from "react-router-dom";
import $ from "jquery";
import {
  Row,
  Col,
  Card,
  Carousel,
  Modal,
  Alert,
  Accordion,
  Collapse,
  Button,
} from "react-bootstrap";
import { toast } from "react-hot-toast";
import PsContext from "../../../context/PsContext";
import API from "../../../utils/API";
import { Api } from "../../../utils/Variables";
import SizeChart from "../../../assets/img/chart.PNG";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import PAY1 from "../../../assets/img/payments/1.png";
import PAY2 from "../../../assets/img/payments/2.png";
import PAY3 from "../../../assets/img/payments/3.png";
import PAY4 from "../../../assets/img/payments/4.png";
import PAY5 from "../../../assets/img/payments/6.png";
import { Nav, Tab } from "react-bootstrap";
import SINGLE from "../../../assets/img/single.png";
const SingleProductView = (props) => {
  const context = useContext(PsContext);
  const { slug, id } = props.match.params;
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [sizeChart, setSizeChart] = useState(false);
  const [product, setProduct] = useState([]);
  const [features, setFeatures] = useState([]);
  const [images, setImages] = useState([]);
  const [qty, setQty] = useState(1);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [activeTab, setActiveTab] = useState("");
  const [offer, setOffer] = useState([]);
  const [image, setLImage] = useState([]);

  const [activeKey, setActiveKey] = useState(null);

  const toggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  useEffect(() => {
    loadProduct();
    loadProductFeatures();
    loadProductImages();
    bodyToTop();
  }, [id]);

  const bodyToTop = () => {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  };

  const loadProduct = () => {
    API.get("v1/site/item/product/" + id).then((res) => {
      if (res["data"].status == "1") {
        //salesdiscount
        //salesrate
        var p = res["data"].data[0];
        p.offer_id = null;
        p.offer_group = null;
        p.offer_value = null;
        p.offer_type = null;
        p.offer_name = null;
        if (res["data"].offer.length > 0) {
          var off = res["data"].offer[0];
          var amt_minus =
            (parseFloat(p.salesrate) * parseFloat(off.value)) / 100;
          var srate = parseFloat(p.salesrate) - parseFloat(amt_minus);
          p.salesdiscount = parseFloat(p.salesrate).toFixed(2);
          p.salesrate = parseFloat(srate).toFixed(2);
          p.offer_id = off.id;
          p.offer_group = off.offer_group;
          p.offer_value = off.value;
          p.offer_name = off.name;
          p.offer_type = "percentage";
          setOffer(off);
        }
        setProduct(p);
      } else {
        setLoader(false);
      }
    });
  };

  const allImages = [
    ...(product.image
      ? [{ image: product.image, itemname: product.itemname }]
      : []),
    ...(images || []),
    ...[1, 2, 3, 4, 5]
      .map((num) => {
        const imgKey = `image${num}`;
        if (product[imgKey]) {
          return { image: product[imgKey], itemname: product.itemname };
        }
        return null;
      })
      .filter(Boolean),
  ];

  const lImage = allImages.map((item) => Api.CloudImageUrl + item.image);
  useEffect(() => {
    if (features.length > 0) {
      setActiveTab(features[0].field);
    }
  }, [features]);

  const loadProductFeatures = () => {
    setLoader(true);
    API.get("v1/site/item/features/" + id).then((res) => {
      if (res["data"].status === "1") {
        setFeatures(res["data"].data);
      }
      setLoader(false);
    });
  };

  const loadProductImages = () => {
    setLoader(true);
    API.get("v1/site/item/images/" + id).then((res) => {
      console.log(res["data"]);
      if (res["data"].status == "1") {
        let s = [];
        res["data"].data.map((item, i) => {
          s.push(Api.CloudImageUrl + item.image);
        });
        setImages(res["data"].data);
        setLImage(s);
        setLoader(false);
      } else {
        setLoader(false);
      }
    });
  };

  const addToCart = () => {
    var dat = product;
    dat["quantity"] = qty;
    context.addToCart(dat);
    toast.success("Successfully added to cart!.");
  };

  if (!loader) {
    return (
      <>
        <div className="tf-page-title mb-50 tf-lg-hidden">
          <div className="container-full">
            <div className="heading text-center">{product.itemname}</div>
            <p className="text-center text-2 text_black-2 mt_5">Our Products</p>
          </div>
        </div>

        <section className="flat-spacing-4 pt_0">
          <div className="tf-main-product">
            <div className="container">
              <Row style={{ position: "relative" }}>
                <Col md={6}>
                  <Card className="card-style1">
                    <Card.Body>
                      <div className="tf-product-media-wrap sticky-top">
                        <div className="thumbs-slider thumbs-default">
                          <Row className="d-flex align-items-stretch flex-wrap flex-row-reverse">
                            {/* Carousel */}
                            <Col xs={12} md={9} className="p-0 m-0">
                              <div
                                className="h-100 tf-product-media-main tf-product-media-main-default d-flex flex-column justify-content-center"
                                dir="ltr"
                              >
                                <Carousel
                                  activeIndex={photoIndex}
                                  onSelect={(selectedIndex) =>
                                    setPhotoIndex(selectedIndex)
                                  }
                                  controls={true}
                                  indicators={false}
                                  nextLabel=""
                                  prevLabel=""
                                  className="product-carousel"
                                >
                                  {allImages && allImages.length > 0 ? (
                                    allImages.map((item, i) => (
                                      <Carousel.Item
                                        key={i}
                                        className="swiper-slide"
                                      >
                                        <a
                                          href="#!"
                                          className="item"
                                          onClick={() => setIsOpen(true)}
                                        >
                                          <img
                                            className="lazyload d-block w-100 product_laze_placeholder"
                                            src={
                                              item.image
                                                ? Api.CloudImageUrl + item.image
                                                : "path_to_default_image.jpg"
                                            }
                                            alt={item.itemname}
                                            style={{
                                              minHeight: "400px",
                                              objectFit: "contain",
                                            }}
                                          />
                                        </a>
                                      </Carousel.Item>
                                    ))
                                  ) : (
                                    <Carousel.Item>
                                      <img
                                        className="d-block w-100"
                                        alt={product.itemname}
                                        src={Api.CloudImageUrl + product.image}
                                      />
                                    </Carousel.Item>
                                  )}
                                </Carousel>
                              </div>
                            </Col>
                            {/* Image Thumbnails */}
                            <Col
                              xs={12}
                              md={3}
                              className="mb-3 mb-md-0 p-0 m-0"
                            >
                              <div
                                className="h-100 d-flex flex-row flex-md-column gap-2
                                 tf-product-media-thumbs tf-product-media-thumbs-default"
                                dir="ltr"
                              >
                                {allImages &&
                                  allImages.map((item, index) => (
                                    <div
                                      className={`swiper-slide mob-thumb stagger-item ${
                                        index === photoIndex
                                          ? "border border-primary"
                                          : ""
                                      }`}
                                      data-color={item.color}
                                      key={index}
                                      onClick={() => setPhotoIndex(index)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "5px",
                                        // width: "80px",
                                      }}
                                    >
                                      <div className="item">
                                        <img
                                          src={
                                            item.image
                                              ? Api.CloudImageUrl + item.image
                                              : ""
                                          }
                                          alt={item.itemname}
                                          className="lazyload img-fluid"
                                          style={{ objectFit: "cover" }}
                                        />
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>

                  {/* Lightbox */}
                  {isOpen && (
                    <Lightbox
                      mainSrc={lImage[photoIndex]}
                      nextSrc={lImage[(photoIndex + 1) % lImage.length]}
                      prevSrc={
                        lImage[(photoIndex + lImage.length - 1) % lImage.length]
                      }
                      onCloseRequest={() => setIsOpen(false)}
                      onMovePrevRequest={() =>
                        setPhotoIndex(
                          (photoIndex + lImage.length - 1) % lImage.length
                        )
                      }
                      onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % lImage.length)
                      }
                    />
                  )}
                </Col>

                <Col md={6} className="mt-20">
                  <div className="side-header">
                    <p className="text-muted">
                      <Link className="text-muted" to="/">
                        Home
                      </Link>
                      / {product.itemname}
                    </p>
                  </div>
                  <div className="tf-product-info-wrap position-relative">
                    <div className="tf-zoom-main"></div>
                    <div className="tf-product-info-list other-image-zoom">
                      <div className="tf-product-info-title single-name">
                        <h5 className="fw-bolder text-capitalize">
                          {product.itemname}
                          {offer && offer.id && (
                            <span
                              className="badge badge-warning off-badge"
                              style={{ fontSize: "15px", marginBottom: "5px" }}
                            >
                              {offer.name} OFF
                            </span>
                          )}
                        </h5>
                      </div>
                      <div className="tf-product-info-price mb-0">
                        <div className="price-on-sale text_black fw-bolder p-0 m-0">
                          <div>
                            <span className="mrp">MRP:</span>
                            {product.salesdiscount > 0 ? (
                              <span
                                className="del text-muted"
                                style={{
                                  fontSize: "15px",
                                  marginLeft: "10px",
                                  textDecoration: "line-through",
                                }}
                              >
                                ₹ {product.salesrate}
                              </span>
                            ) : (
                              ""
                            )}
                            <span
                              style={{
                                fontSize: "22px",
                                marginLeft: "10px",
                                fontWeight: "600",
                              }}
                            >
                              ₹{" "}
                              {qty *
                                (product.salesdiscount > 0
                                  ? product.discount_sales_rate
                                  : product.salesrate)}
                            </span>
                            {product.salesdiscount > 0 && (
                              <span
                                style={{
                                  fontSize: "15px",
                                  marginLeft: "10px",
                                  fontWeight: "600",
                                  color: "green",
                                }}
                              >
                                {qty * product.salesdiscount} % Off
                              </span>
                            )}
                          </div>
                          <div style={{ position: "relative", top: "-15px" }}>
                            <p style={{ color: "#9e8873", fontSize: "13px" }}>
                              Inclusive of All Taxes
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="tf-product-info-variant-picker">
                        <div className="variant-picker-item">
                          <div className="d-flex gap-30 align-items-top">
                            <div className="variant-picker-label">
                              <span
                                className=""
                                style={{
                                  fontSize: "15px",
                                  marginRight: "10px",
                                }}
                              >
                                {" "}
                                Size:
                              </span>
                              <span
                                className="variant-picker-label-value"
                                style={{
                                  fontSize: "15px",
                                  marginRight: "10px",
                                }}
                              >
                                {product.i_size}
                              </span>
                              {/* <span className="fw-6 variant-picker-label-value me-2">
                                {product.i_size}
                              </span> */}
                              {product &&
                                product.showsizechart &&
                                product.showsizechart == "0" && (
                                  <a
                                    href="javascript:;"
                                    style={{
                                      fontSize: "13px",
                                      color: "#9e8873",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => setSizeChart(true)}
                                  >
                                    (See size chart)
                                  </a>
                                )}

                              {/* <div className="variant-picker-values">
                                <input
                                  type="radio"
                                  name="size1"
                                  id="values-s"
                                  checked=""
                                />
                                <label
                                  className="style-text size-btn"
                                  for="values-s"
                                  data-value="S"
                                >
                                  <p> {product.i_size}</p>
                                </label>
                              </div> */}

                              {/* <p>{product.more_info}</p> */}
                            </div>
                            <div>
                              <p>
                                <span
                                  className="span1"
                                  style={{
                                    fontSize: "15px",
                                    marginRight: "10px",
                                  }}
                                >
                                  {" "}
                                  Color:
                                </span>
                                <span className="variant-picker-label-value fs-13">
                                  {product.color}
                                </span>
                              </p>
                            </div>
                          </div>

                          {product && parseFloat(product.stockinhand) > 0 && (
                            <>
                              {/* <div className="tf-product-info-quantity d-flex gap-20 align-content-center">
                                <div className="quantity-title fw-6">
                                  Quantity
                                </div>
                                <div className="wg-quantity">
                                  <span
                                    className="btn-quantity btn-decrease"
                                    onClick={() => qty > 1 && setQty(qty - 1)}
                                  >
                                    -
                                  </span>
                                  <input
                                    type="text"
                                    className="quantity-product"
                                    name="number"
                                    value={qty}
                                    readOnly
                                  />
                                  <span
                                    className="btn-quantity btn-increase"
                                    onClick={() => setQty(qty + 1)}
                                  >
                                    +
                                  </span>
                                </div>
                              </div> */}

                              <div className="tf-product-info-buy-button">
                                <div className="row">
                                  <div className="col-6">
                                    <form>
                                      <a
                                        href="javascript:void(0);"
                                        className="tf-btn btn-fill text-dark bg-theme border-0 justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn btn-add-to-cart"
                                        onClick={() => addToCart(qty)}
                                      >
                                        <span
                                          style={{
                                            fontSize: "15px",
                                            color: "#000",
                                            textTransform: "uppercase",
                                            fontWeight: "400",
                                          }}
                                        >
                                          Add to cart
                                        </span>
                                        {/* <i className="fas fa-shopping-cart ms-2 text-dark"></i> */}
                                      </a>
                                    </form>
                                  </div>
                                  <div className="col-6">
                                    <form>
                                      <a
                                        href="javascript:void(0);"
                                        className="tf-btn btn-fill bg-theme-line-btn justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn btn-add-to-cart"
                                        onClick={() => addToCart(qty)}
                                      >
                                        <span
                                          style={{
                                            fontSize: "15px",
                                            color: "#f58b76",
                                            textTransform: "uppercase",
                                            fontWeight: "400",
                                          }}
                                        >
                                          Buy Now
                                          {/* <i class="fa fa-bolt"></i> */}
                                        </span>
                                      </a>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}

                          {product && parseFloat(product.stockinhand) < 1 && (
                            <div className="mt-15">
                              <div className="alert alert-danger" role="alert">
                                No Stock available
                              </div>
                            </div>
                          )}

                          {product && product.about && (
                            <div className="mt-15">
                              <hr />
                              <h5>Description</h5>
                              <hr />
                              <p>{product.about}</p>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="details mt-20">
                        <hr />
                        {product.more_info && (
                          <div>
                            <h6 className="mt-20">Product Details</h6>
                            <p style={{ lineHeight: "1.8" }}>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: product.more_info,
                                }}
                              />
                            </p>
                          </div>
                        )}
                        {product.meterialcare && (
                          <div>
                            <h6>Material & Care</h6>
                            <p style={{ lineHeight: "1.8" }}>
                              {product.meterialcare} <br /> Dry Wash Only
                            </p>
                          </div>
                        )}

                        {product.hsn && (
                          <div>
                            <h6>Product Code</h6>
                            <p style={{ lineHeight: "2.5" }}>{product.hsn}</p>
                            <p
                              style={{
                                position: "relative",
                                top: "-15px",
                                fontSize: "9px",
                              }}
                            >
                              Note: Product color may slightly vary due to
                              photographic lighting sources or your monitor
                              settings.
                            </p>
                          </div>
                        )}
                      </div>
                      <hr />
                      <div className="accordion-custom">
                        <div className="accordion-item-custom">
                          <div
                            className="accordion-toggle-custom"
                            onClick={() => toggle(0)}
                            aria-controls="specifications"
                            aria-expanded={activeKey === 0}
                          >
                            Product Specifications
                            <i
                              className={`fa fa-chevron-down arrow ${
                                activeKey === 0 ? "rotate" : ""
                              }`}
                            />
                          </div>
                          <Collapse in={activeKey === 0}>
                            <div
                              id="specifications"
                              className="accordion-body-custom"
                            >
                              {/* {product.itemcategory && (
                                <p>Product Category : {product.itemcategory}</p>
                              )} */}
                              {product.stockinhand && (
                                <p>
                                  <b>Available Stocks</b> :{" "}
                                  {product.stockinhand}
                                </p>
                              )}

                              {product.secondryfabric && (
                                <p>
                                  <b>Fabric</b> : {product.secondryfabric}
                                </p>
                              )}
                              {product.work && (
                                <p>
                                  <b>Work</b> : {product.work}
                                </p>
                              )}
                              {product.color && (
                                <p>
                                  <b>Color</b> : {product.color}
                                </p>
                              )}
                              {product.secondrywork && (
                                <p>
                                  <b>Secondary Work</b> : {product.secondrywork}
                                </p>
                              )}
                              {product.neckline && (
                                <p>
                                  <b>Neckline</b> : {product.neckline}
                                </p>
                              )}
                              {product.sleevetype && (
                                <p>
                                  <b>Sleeve Type</b> : {product.sleevetype}
                                </p>
                              )}
                              {product.brand && <p>Brand : {product.brand}</p>}
                              {product.otheraccessries && (
                                <p>
                                  <b> Other Accessories</b> :{" "}
                                  {product.otheraccessries}
                                </p>
                              )}
                              {product.bottomstyle && (
                                <p>
                                  <b>Bottom Style</b> : {product.bottomstyle}{" "}
                                </p>
                              )}
                              {product.topstyle && (
                                <p>
                                  <b>Top Style</b> : {product.topstyle}
                                </p>
                              )}
                              {product.packcontains && (
                                <p>
                                  <b>Pack Contains</b> : {product.packcontains}
                                </p>
                              )}
                            </div>
                          </Collapse>

                          <div
                            className="accordion-toggle-custom"
                            onClick={() => toggle(1)}
                            aria-controls="shipping"
                            aria-expanded={activeKey === 1}
                          >
                            Shipping Information
                            <i
                              className={`fa fa-chevron-down arrow ${
                                activeKey === 1 ? "rotate" : ""
                              }`}
                            />
                          </div>
                          <Collapse in={activeKey === 1}>
                            <div
                              id="shipping"
                              className="accordion-body-custom"
                            >
                              <p>
                                <b>Dispatch : </b> Within 48 Hours*
                              </p>
                              <p>
                                <b>Delivery Time (Metro Cities):</b> 1-3*
                                business days
                              </p>
                              <p>
                                <b>Delivery Time (Non-Metro Cities):</b> 3-5*
                                business days
                              </p>
                              <p>
                                <b>Return/Exchange:</b> If you don't like your
                                purchase, Return/Exchange within 7 days
                              </p>
                            </div>
                          </Collapse>

                          <div
                            className="accordion-toggle-custom"
                            onClick={() => toggle(2)}
                            aria-controls="shipping"
                            aria-expanded={activeKey === 2}
                          >
                            More Information
                            <i
                              className={`fa fa-chevron-down arrow ${
                                activeKey === 1 ? "rotate" : ""
                              }`}
                            />
                          </div>
                          <Collapse in={activeKey === 2}>
                            <div
                              id="shipping"
                              className="accordion-body-custom"
                            >
                              <p style={{ fontSize: "13px" }}>
                                <b>Packed and Marketed By</b>
                              </p>
                              <p>
                                <b>Shibani Fashion</b>
                              </p>
                              <p>
                                No.1, Market Road, Colachel, Tamil Nadu 629251
                              </p>
                              <p> shibanifashion2015@gmail.com</p>
                              <p>6374327362</p>
                            </div>
                          </Collapse>

                          <div
                            className="accordion-toggle-custom"
                            onClick={() => toggle(3)}
                            aria-controls="shipping"
                            aria-expanded={activeKey === 3}
                          >
                            Need Help
                            <i
                              className={`fa fa-chevron-down arrow ${
                                activeKey === 1 ? "rotate" : ""
                              }`}
                            />
                          </div>
                          <Collapse in={activeKey === 3}>
                            <div
                              id="shipping"
                              className="accordion-body-custom"
                            >
                              <p>
                                <b>Call</b> : 6374327362
                              </p>
                              <p>
                                <b>Email</b> : shibanifashion2015@gmail.com
                              </p>
                              <p>
                                <b>WhatsApp</b> : 6374327362
                              </p>
                              {/* <p>
                                <b>Grievance officer</b> : 6374327362
                              </p> */}
                            </div>
                          </Collapse>
                        </div>
                      </div>
                      <div className="img mt-30">
                        <img src={SINGLE} className="w-100" />
                      </div>
                      <div className="accordion-custom">
                        <div className="accordion-item-custom">
                          <div
                            className="accordion-toggle-custom"
                            onClick={() => toggle(5)}
                            aria-controls="specifications"
                            aria-expanded={activeKey === 5}
                          >
                            How to Avai Buy 2 Get 1 Free
                            <i
                              className={`fa fa-chevron-down arrow ${
                                activeKey === 0 ? "rotate" : ""
                              }`}
                            />
                          </div>
                          <Collapse in={activeKey === 5}>
                            <div
                              id="specifications"
                              className="accordion-body-custom"
                            >
                              <p>
                                Buy 2 Get 1 Free offer is available on Designer
                                Sarees, Unstitched Salwar Suits, Blouses and
                                Dupatta. To avail the Buy 2 Get 1 Free offer add
                                any 3 products with the BUY 2 GET 1 OFFER to the
                                cart. The product with the lowest price will be
                                added to the cart as a free product
                              </p>
                            </div>
                          </Collapse>
                          <div
                            className="accordion-toggle-custom"
                            onClick={() => toggle(6)}
                            aria-controls="specifications"
                            aria-expanded={activeKey === 6}
                          >
                            FAQ's
                            <i
                              className={`fa fa-chevron-down arrow ${
                                activeKey === 0 ? "rotate" : ""
                              }`}
                            />
                          </div>
                          <Collapse in={activeKey === 6}>
                            <div
                              id="specifications"
                              className="accordion-body-custom"
                            >
                              <p>
                                <b>1. How can I track track my order?</b>
                              </p>
                              <p>
                                To check the status of your order, click on
                                ‘Track your order’ to see the real-time update
                              </p>
                              <p>
                                <b>
                                  2. Are the colours of the products shown on
                                  the website accurate?
                                </b>
                              </p>
                              <p>
                                The colours of the products on our website have
                                been portrayed as accurately as possible,
                                however, monitors and screens of electronics
                                devices differ in their display of colour, so it
                                may slightly vary depending on the display
                                screen.
                              </p>
                              <p>
                                <b>
                                  3. What is your return and exchange policy?
                                </b>
                              </p>
                              <p>
                                Our returns and exchange policy gives you an
                                option to return or exchange items purchased
                                from our website for any reason within 7 days of
                                receipt of the item. We only ask that you don't
                                use the product and preserve its original
                                condition, tags and packaging.
                              </p>
                              <p>
                                <b>
                                  4. What is the difference between unstitched,
                                  semi-stitched and readymade products?
                                </b>
                              </p>
                              <p>
                                <b>Unstitched</b> products are fabric materials
                                which can be stitched by the customer to your
                                exact size.
                              </p>
                              <p>
                                <b>Semi-stitched</b> products come
                                half-stitched. For example, semi-stitched
                                lehengas have a blouse material but the skirt is
                                half-stitched. So, you will have to tailor it to
                                your size.
                              </p>
                              <p>
                                <b>Readymade</b> products are ready to wear
                                according to pre-set sizes like S, M L, XL etc.
                              </p>
                            </div>
                          </Collapse>
                          <div
                            className="accordion-toggle-custom"
                            onClick={() => toggle(7)}
                            aria-controls="specifications"
                            aria-expanded={activeKey === 7}
                          >
                            Return Policy
                            <i
                              className={`fa fa-chevron-down arrow ${
                                activeKey === 0 ? "rotate" : ""
                              }`}
                            />
                          </div>
                          <Collapse in={activeKey === 7}>
                            <div
                              id="specifications"
                              className="accordion-body-custom"
                            >
                              <p>
                                <b>1. Easy Returns</b>
                              </p>
                              <p>
                                Looking at returning/exchanging your product?
                                It’s simple. You have to raise a return request
                                within 7 days of delivery of the product.
                              </p>
                              <p>
                                <b>2. How can I raise a return request?</b>
                              </p>
                              <p>
                                Please reach out to support@koskii.com within 7
                                days of order delivery. Our customer support
                                team will get back to you within 48 hours of
                                receiving the request.
                              </p>
                              <p>
                                <b>
                                  {" "}
                                  3. Can I return some products from a bundle
                                  offer (Buy 2 and Get 1 Free, Buy 3 and Get 50%
                                  OFF etc.) and still remain eligible for the
                                  offer?
                                </b>
                              </p>
                              <p>
                                No, if you decide to return only a portion of
                                the products included in a bundle offer, the
                                offer for the bundle discount ( Buy 2 and Get 1
                                Free, Buy 3 and Get 50% OFF etc.) may no longer
                                be valid.
                              </p>
                            </div>
                          </Collapse>
                        </div>
                      </div>
                      <div class="tf-product-info-delivery-return">
                        <div class="row">
                          <div class="col-xl-6 col-12">
                            <div class="tf-product-delivery h-100">
                              <div class="icon">
                                <i class="icon-delivery-time"></i>
                              </div>
                              <p className="fs-13">
                                Estimate delivery times:{" "}
                                <span class="fw-7">12-26 days</span>{" "}
                                (International),{" "}
                                <span class="fw-7">3-6 days</span> (India).
                              </p>
                            </div>
                          </div>
                          <div class="col-xl-6 col-12">
                            <div class="tf-product-delivery h-100">
                              <div class="icon">
                                <i class="icon-return-order"></i>
                              </div>
                              <p className="fs-13">
                                Return within <span class="fw-7">30 days</span>{" "}
                                of purchase. Duties & taxes are non-refundable.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tf-product-info-trust-seal">
                        <div class="tf-product-trust-mess">
                          <i class="icon-safe"></i>
                          <p class="fw-6 fs-13">
                            Guarantee Safe <br /> Checkout
                          </p>
                        </div>
                        <div class="tf-payment">
                          <img src={PAY1} />
                          <img src={PAY2} />
                          <img src={PAY3} />
                          <img src={PAY4} />
                          <img src={PAY5} />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </section>

        <section className="flat-spacing-17 pt_0">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {features && features.length > 0 && (
                  <div className="widget-tabs style-has-border">
                    {/* Tabs Navigation */}
                    <ul className="widget-menu-tab">
                      {features.map((item, index) => (
                        <li
                          key={index}
                          className={`item-title ${
                            activeTab === item.field ? "active" : ""
                          }`}
                          onClick={() => setActiveTab(item.field)}
                        >
                          <span className="inner">{item.field}</span>
                        </li>
                      ))}
                    </ul>

                    {/* Tabs Content */}
                    <div className="widget-content-tab">
                      {features.map((item, index) => (
                        <div
                          key={index}
                          className={`widget-content-inner ${
                            activeTab === item.field ? "active" : ""
                          }`}
                        >
                          <div className="p-3 border rounded">{item.value}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        <Modal show={sizeChart} size="lg" onHide={() => setSizeChart(false)}>
          <Modal.Header closeButton>Size Chart</Modal.Header>
          <Modal.Body>
            <img src={SizeChart} style={{ width: "100%" }} />
          </Modal.Body>
        </Modal>

        {isOpen && (
          <Lightbox
            mainSrc={lImage[photoIndex]}
            nextSrc={lImage[(photoIndex + 1) % lImage.length]}
            prevSrc={lImage[(photoIndex + lImage.length - 1) % lImage.length]}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() =>
              setPhotoIndex((photoIndex + lImage.length - 1) % lImage.length)
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % lImage.length)
            }
          />
        )}
      </>
    );
  } else {
    return (
      <Row>
        <Col md={12} style={{ paddingTop: "100px" }}>
          <center>
            <div className="ps_round_loader"></div>
          </center>
        </Col>
      </Row>
    );
  }
};

export default withRouter(SingleProductView);
